// src/EfficiencyReferenceLines.jsx
import React from 'react';
import { ReferenceLine } from 'recharts';

export const configEfficiencyLines = ( scenario ) => {
  // Отсечки эффективности
  const greenTrendlineVal = scenario?.green_line;
  const yelowTrendlineVal = scenario?.yellow_line;
  const redTrendlineVal   = scenario?.red_line;
  return [
    {
      y: greenTrendlineVal,
      stroke: '#5EA24D',
      labelFill: '#28a745',
    },
    {
      y: yelowTrendlineVal,
      stroke: '#FFE11F',
      labelFill: '#e2cc00',
    },
    {
      y: redTrendlineVal,
      stroke: '#FF5E5E',
      labelFill: '#FF5E5E',
    }
  ]
};
